import { Subject } from 'rxjs';

export class AddToHomeEventEmitter extends Subject<any>{
    constructor() {
        super();
    }
    emit(value) { super.next(value); }
}